




































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { client, authorClient } from "@/api/index";
import { localGet, localSet, setMetaData } from "@/utils/index";
import { handleResponse, setCommon, errorMsg } from "@/utils/request";
import {
  LoginReq,
  CommitTwoFactAuthCodeReq,
  GetTwoFactAuthQRReq,
  EnterSystemReq,
} from "@/pbjs/external/user/user_pb";
import { GsiReq } from "@/pbjs/external/auth/auth_pb";
import {
  CaptchaReq,
} from "@/pbjs/xcommon/user_pb";
import { Decision } from "@/pbjs/xcommon/common_pb";
const GoogleAuth = () => import("./components/GoogleAuth.vue");
const QRCode = () => import("./components/QRCode.vue");

@Component({
  name: "login",
  components: { GoogleAuth, QRCode },
})
export default class Login extends Vue {
  @Provide() private email: string = "";
  @Provide() private password: string = "";
  @Provide() private ruleForm: any = { username: "", password: "" };
  // @Provide() private checked: any = false; //暂时的关闭此功能
  @Provide() private isLoginDone: boolean = false;
  @Provide() private isLoginDisabled: boolean = false;
  @Provide() private rules: any = {
    username: [{ required: true, message: "请输入", trigger: "blur" }],
    password: [{ required: true, message: "请输入", trigger: "blur" }],
    captchaCode: [{ required: true, message: "请输入", trigger: "blur" }],
  };
  @Provide() private showDialogType: number = 0;
  @Provide() private qrCodeBase64: any = "";
  @Provide() private captchaInfo: any = {
  captcha: "",
  captchaId: ''
    
  };
  @Provide() private loginTips: any = {
    tipsCn: '系统数据是公司的重要资产，仅限工作适用，请勿将数据私用。为了数据安全，任何操作行为均会被保存记录，私用数据将被严重追责! ',
    tipsEn: 'System data is an important asset of the company and is only applicable to work, please do not use the data privately. For data security, any operation will be recorded, and private data will be severely held accountable!',
    tipsAr: 'تعد بيانات النظام الأصول المهمة للشركة ويجب استخدامها فقط للعمل ، يرجى عدم استخدامها بشكل خاص. سيقوم بتسجيل أي عملية وحفظها لأمن البيانات، ، وستتم محاسبة استخدام البيانات الخاصة بشكل صارم!',
    tipsId: 'Data didalam sistem adalah aset terpenting dalam perusahaan yang hanya digunakan untuk kepentingan pekerjaan, mohon untuk tidak menggunakan data perusahaan untuk kepentingan pribadi. Untuk memastikan keamanan data, setiap aktivitas apa pun akan direkam dalam riwayat, dan penggunaan data perusahaan untuk kepentingan pribadi akan dimintai pertanggungjawabannya!',
    tipsEs: 'La información registrada en el sistema es importante para la empresa y solo se usa con fines de trabajo, no utilice estos datos de forma privada. Para la seguridad de la información, cualquier operación realizada se registrará,en caso de incumplimiento se reserva el derecho de ejercer todas aquellas acciones legales!'
}
  @Provide() private tips: any = ""

  private created() {
    document.onkeydown = (e: any) => {
      e = window.event || e;
      if (e.code === "Enter") {
        //验证在登录界面和按得键是回车键enter
        this.submitForm("ruleForm");
      }
    };
  }
  private mounted() {
    // <!--temporary hidden-->
    //     localStorage.setItem("cn", 'en-US');
    this.getGsi();
    this.getCookie();
  }
  private getCapBtn() {
    // <!--temporary hidden-->
    //     localStorage.setItem("cn", 'en-US');
    this.getCaptcha('btn');
  }

  private async getCaptcha(type: any) {
    this.isLoginDone = true;
    let request: any = new CaptchaReq();
    // request.setCommonin(setCommon());
    request.setTrackid("");
    request.setClientid("");
    request.setWidth(140);
    request.setHeight(48);
    request.setLength(6);
    request.setEmail(this.ruleForm.username.trim()); // 用户名
    console.log("setCaptchaReq", request);
    client.captcha(request, setMetaData(), (err: any, response: any) => {
    console.log(err, response, '----setCaptchaRes-----')
      if (response) {
        this.isLoginDone = false;
        let data: any = response.toObject();
        console.log(data, "captcha");
        this.captchaInfo = {
          ...data
        }
        // 1 时 需要输入验证码
        if (data.showcaptcha === 1 && !this.ruleForm.captchaCode) {
          // type && type === 'login' && this.$message.error('captcha is error!')
        } else {
          // 正常调用 login 接口
          type && type === 'login' && this.login();
        }
      } else {
        this.isLoginDone = false;
        this.$message.error(err.errmsg || err.message);
        return false;
      }
      
    });
  }

  private returnIsShow(type: number) {
    this.showDialogType = type;
  }

  //   private returnAuthCode(authCode: number | null) {
  //       this.commitTwoFactAuthCode()
  //   }

  private getCookie() {
    if (document.cookie.length > 0) {
      var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split("="); //再次切割
        //判断查找相对应的值
        if (arr2[0] == "userName") {
          console.log(arr2[1], arr2[1]);
          this.ruleForm.username = arr2[1]; //保存到保存数据的地方
        }
        // } else if (arr2[0] == "userPwd") {
        //   this.ruleForm.password = arr2[1];
        //   this.checked = true;
        // }
      }
    }
    // this.checked=true;
  }

  private clearCookie() {
    this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
  }

  private setCookie(c_name: string, c_pwd: string, exdays: number) {
    var exdate = new Date(); //获取时间
    exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
    //字符串拼接cookie
    window.document.cookie =
      "userName" + "=" + c_name + ";path=/;expires=" + exdate.toUTCString();
    // window.document.cookie =
    //   "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toUTCString();
  }

  private submitForm(formName: string) {
    this.isLoginDone = true;
    const ref: any = this.$refs[formName];
    ref.validate((valid: boolean) => {
      if (valid) {
        const self = this;
        //判断复选框是否被勾选 勾选则调用配置cookie方法
        // if (self.checked == true) {
        // console.log("checked == true");
        //传入账号名，密码，和保存天数3个参数
        console.log(self.ruleForm.username, self.ruleForm.password);
        // self.setCookie(self.ruleForm.username, self.ruleForm.password, 365);
        self.setCookie(self.ruleForm.username, "", 365);
        // let _ech = document.createElement("script");
        // _ech.setAttribute(
        //   "src",
        //   "https://cdnjs.cloudflare.com/ajax/libs/echarts/4.8.0/echarts.min.js"
        // );
        // document
        //   .getElementsByTagName("head")[0]
        //   .insertBefore(_ech, document.getElementsByTagName("title")[0]);
        // console.log(_ech);
        // } else {
        //   console.log("清空Cookie");
        //   //清空Cookie
        //   self.clearCookie();
        // }
        if (!this.ruleForm.captchaCode) {
          this.getCaptcha('login');
        } else {
          self.login();
        }
        // self.login();
      } else {
        console.log("error submit!!");
        this.isLoginDone = false;
        return false;
      }
    });
  }

  private loginFuc(data: any) {
    let obj: any = {
      token: data.onetimetoken,
      userid: 0,
      name: null,
      email: this.ruleForm.username,
    };
    this.$store.dispatch("storeUser", obj);
    console.log(obj, "obj");
    if (data.gototwofactauth) {
      if (data.scantwofactauthqr) {
        this.getTwoFactAuthQR();
      } else {
        this.showDialogType = 1;
      }
    } else {
      this.enterSystem();
    }
  }
  private login() {
    this.isLoginDone = true;
    let request: any = new LoginReq();
    request.setTrackid("");
    request.setClientid("");
    request.setEmail(this.ruleForm.username.trim());
    request.setPassword(this.ruleForm.password.trim());
    request.setCaptchacode("");
    // 当有验证码时
    if(this.captchaInfo.showcaptcha === 1){
    request.setCaptchaid(this.captchaInfo.captchaid);
    request.setCaptchacode(this.ruleForm.captchaCode);
    }
    console.log(request, "LoginReq");
    client.login(request, setMetaData(), (err: any, response: any) => {
      if (response) {
        this.isLoginDone = false;
        let data: any = response.toObject();
        console.log(data, "login");
        // commonout.code !== 0 获取新的验证码
        if (data?.commonout?.code !== 0) {
          this.ruleForm.captchaCode = null;
          this.getCaptcha('btn');
        }
        let _loginFuc = this.loginFuc;
        handleResponse(data, _loginFuc);
      } else {
        this.isLoginDone = false;
        // 失败后更新验证码
        this.ruleForm.captchaCode = null;
        this.getCaptcha('btn');
        this.$message.error(err.errmsg || err.message);
      }
      // this.isLoginDone = false;
    });
  }

  private commitTwoFactAuthCode(authCode: string) {
    let commitTwoFactAuthCodeFunc: any = (data: any) => {
      if (data.decision === Decision.DECISION_ALLOW) {
        this.enterSystem();
      } else {
        this.$message.error("Auth code is wrong");
      }
    };
    let request: any = new CommitTwoFactAuthCodeReq();
    request.setCommonin(setCommon());
    request.setTwofactauthcode(authCode + "");
    client.commitTwoFactAuthCode(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        console.log(data, "commitTwoFactAuthCode");
        handleResponse(data, commitTwoFactAuthCodeFunc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private enterSystem() {
    this.isLoginDone = true;
    let enterSystemFunc: any = (data: any) => {
      data.successdata.email = this.ruleForm.username;
      this.$store.dispatch("storeUser", data.successdata);
      console.log("storeUser", data.successdata)
      this.$router.push("./Performance/dashboard");
      // this.isLoginDone = false;
    };
    let request: any = new EnterSystemReq();
    request.setCommonin(setCommon());
    client.enterSystem(request, {}, (err: any, response: any) => {
      if (response) {
        // this.isLoginDone = false;
        let data: any = response.toObject();
        // "{"name":"YumiCash-PRO","abbreviation":"MPYC","lang":"mx","lang_list":{"en":true,"cn":true,"mx":true,"vn":false}}"
        // "{"name":"YumiCash-PRO","abbreviation":"MPYC","lang":"mx","lang_list":{"en":true,"cn":true,"mx":true,"vn":false},phone_prefix:"0057"}"
        console.log(data, "enterSystem");
        let lang = JSON.parse(data.successdata.systeminfo).lang;
        let abbreviation = JSON.parse(data.successdata.systeminfo).abbreviation;
        const systemInfoAll = data.successdata.systeminfo;
        localStorage.setItem("usergroupid", data.successdata.usergroupid);
        localStorage.setItem("country", lang);
        localStorage.setItem("systemInfo", abbreviation);
        localStorage.setItem("systemInfoAll", systemInfoAll);
        let _str: string = "";
        if (lang && lang === "in") {
          _str = "en-US";
          localStorage.setItem("cn", _str);
        } else {
          if (!localStorage.getItem("cn")) {
            localStorage.setItem("cn", _str);
          }
          _str = "zh-CN";
        }
        sessionStorage.setItem("exectype", data.successdata.exectype);
        handleResponse(data, enterSystemFunc);
      }
      if (err) {
        this.isLoginDone = false;
        errorMsg(err);
      }
    });
  }

  private getGsi() {
    let request: any = new GsiReq();
    request.setTrackid("");
    request.setClientid("");
    authorClient.gsi(request, setMetaData(), (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let c = data.c;
        if(c === 'co' || c === 'mx') {
          this.tips = this.loginTips.tipsEs;
        } else if(c === 'id' || c === 'in') {
          this.tips = this.loginTips.tipsId;
        } else if(c === 'eg') {
          this.tips = this.loginTips.tipsAr;
        } else if(c === 'en' || c === 'pk' || c === 'pe' || c === 'ng') {
          this.tips = this.loginTips.tipsEn;
        }
        console.log(data, "GsiReqGsiReqGsiReqGsiReqGsiReqGsiReq");
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private getTwoFactAuthQR() {
    let getTwoFactAuthQRFunc: any = (data: any) => {
      this.qrCodeBase64 = data.qr;
      this.showDialogType = 2;
    };
    let request: any = new GetTwoFactAuthQRReq();
    request.setCommonin(setCommon());
    client.getTwoFactAuthQR(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        console.log(data, "getTwoFactAuthQR");
        handleResponse(data, getTwoFactAuthQRFunc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
}
